import { DATA_SELECTOR_ID, KL_HIDDEN_CLASS, KL_VISIBLE_CLASS, STORE_SEARCH, STORE_SEARCH_RESULTS } from "../utils/context-layer-variables";
import { insertErrorMessage } from "./search-errors";
import { fetchStoresDecreased } from "../api/decreased-store-search.service";
import { initStoreSearchResultEvents } from "./store-search";
import { CustomerContext } from "../models/CustomerContext";
const CONTEXT_LAYER_COMPONENT = 'component-context-layer';
const STORE_SEARCH_DECREASED = 'store-search-decreased';
const STORE_SEARCH_DECREASED_BUTTON = 'store-search-decreased-button';
const STORE_SEARCH_DECREASED_LOADER = 'store-search-decreased-loader';
const SEARCH_DECREASED_DROPDOWN_NAME = 'storeSearchCity';
let storeSearchContainer;
let storeSearchDecreasedButton;
let storeSearchDecreasedLoader;
let storeSearchCards;
export function initDecreasedViewListener() {
  const contextLayerContainer = document.querySelector(`[${DATA_SELECTOR_ID}="${CONTEXT_LAYER_COMPONENT}"]`);
  storeSearchContainer = contextLayerContainer === null || contextLayerContainer === void 0 ? void 0 : contextLayerContainer.querySelector(`[${DATA_SELECTOR_ID}="${STORE_SEARCH}"]`);
  storeSearchDecreasedButton = storeSearchContainer === null || storeSearchContainer === void 0 ? void 0 : storeSearchContainer.querySelector(`[${DATA_SELECTOR_ID}="${STORE_SEARCH_DECREASED_BUTTON}"]`);
  storeSearchDecreasedLoader = storeSearchContainer === null || storeSearchContainer === void 0 ? void 0 : storeSearchContainer.querySelector(`[${DATA_SELECTOR_ID}="${STORE_SEARCH_DECREASED_LOADER}"]`);
  storeSearchDecreasedButton === null || storeSearchDecreasedButton === void 0 ? void 0 : storeSearchDecreasedButton.addEventListener('click', function () {
    if (storeSearchDecreasedLoader) storeSearchDecreasedLoader.style.display = 'block';
    fetchStoresDecreased(handleSuccess, handleError);
  });
}
function handleSuccess(response) {
  var _a;
  if (storeSearchContainer) {
    storeSearchContainer.innerHTML = response;
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = response;
    const responseElement = tempDiv.firstElementChild;
    const storeResultsContainer = responseElement.querySelector(`[${DATA_SELECTOR_ID}="${STORE_SEARCH_RESULTS}"]`);
    (_a = storeResultsContainer === null || storeResultsContainer === void 0 ? void 0 : storeResultsContainer.firstElementChild) === null || _a === void 0 ? void 0 : _a.classList.add("js-decreased-view");
    initStoreSearchResultEvents(new CustomerContext(), storeSearchContainer, (storeResultsContainer === null || storeResultsContainer === void 0 ? void 0 : storeResultsContainer.innerHTML) || '');
  }
  storeSearchCards = storeSearchContainer === null || storeSearchContainer === void 0 ? void 0 : storeSearchContainer.querySelectorAll(`[${DATA_SELECTOR_ID}="store-search-card"]`);
  storeSearchCards === null || storeSearchCards === void 0 ? void 0 : storeSearchCards.forEach(storeSearchCard => {
    var _a;
    (_a = storeSearchCard === null || storeSearchCard === void 0 ? void 0 : storeSearchCard.classList) === null || _a === void 0 ? void 0 : _a.add(KL_HIDDEN_CLASS);
  });
  filterByCity();
}
function handleError() {
  var _a;
  (_a = storeSearchDecreasedButton === null || storeSearchDecreasedButton === void 0 ? void 0 : storeSearchDecreasedButton.classList) === null || _a === void 0 ? void 0 : _a.add(KL_HIDDEN_CLASS);
  if (storeSearchContainer) insertErrorMessage(storeSearchContainer, context_layer.i18n.store_search_error);
}
function filterByCity() {
  const storeSearchDecreasedContainer = document.querySelector(`[${DATA_SELECTOR_ID}="${STORE_SEARCH_DECREASED}"]`);
  const storeSearchDecreasedDropdownContainer = storeSearchDecreasedContainer === null || storeSearchDecreasedContainer === void 0 ? void 0 : storeSearchDecreasedContainer.querySelector(`select[name="${SEARCH_DECREASED_DROPDOWN_NAME}"]`);
  storeSearchDecreasedDropdownContainer === null || storeSearchDecreasedDropdownContainer === void 0 ? void 0 : storeSearchDecreasedDropdownContainer.addEventListener('change', handleCityChange);
}
function handleCityChange() {
  const selectedCity = this.value;
  storeSearchCards === null || storeSearchCards === void 0 ? void 0 : storeSearchCards.forEach(store => {
    const storeCity = store.getAttribute('data-store-city');
    const isSelectedCity = (storeCity === null || storeCity === void 0 ? void 0 : storeCity.toLowerCase()) === (selectedCity === null || selectedCity === void 0 ? void 0 : selectedCity.toLowerCase());
    handleStoreVisibility(store, isSelectedCity);
  });
}
function handleStoreVisibility(store, isVisible) {
  store.classList.remove(isVisible ? KL_HIDDEN_CLASS : KL_VISIBLE_CLASS);
  store.classList.add(isVisible ? KL_VISIBLE_CLASS : KL_HIDDEN_CLASS);
}